import * as constants from '../Actions/types';
import initialState from './initial-state';

// A list is settled once its request has either returned data or failed. Each list
// tracks its own state so a slow or failed request no longer withholds the lists
// that did load, and so the modal can tell "no matchables" from "the fetch failed".
//
// A settle carrying a requestId that is not the newest started for that list is a
// response from a superseded request and is dropped: it must not overwrite newer data,
// clear the loading flag while a newer request is still running, or repopulate a store
// that CLEAR_MATCH has since reset (a late response from a closed modal).
const settle = (state, list, changes, requestId) => {
  if (state.requests[list] !== requestId) return state;

  const loading = { ...state.loading, [list]: false };
  const errors = { ...state.errors };
  if (changes.error) errors[list] = changes.error;
  else delete errors[list];

  const requested = Object.keys(loading);

  return {
    ...state,
    ...changes.data,
    loading,
    errors,
    loadCompleted: requested.every(item => !loading[item]),
    apiError: requested.length > 0 && requested.every(item => errors[item])
  };
};

export default function(state = initialState.matchables, action) {
  switch (action.type) {

    case constants.MATCH_LIST_START:
      return {
        ...state,
        requests: { ...state.requests, [action.list]: action.requestId },
        loading: { ...state.loading, [action.list]: true },
        errors: Object.keys(state.errors).reduce((kept, list) => {
          if (list !== action.list) kept[list] = state.errors[list];
          return kept;
        }, {}),
        apiError: false,
        loadCompleted: false
      };

    case constants.MATCH_LIST_ERROR:
      return settle(state, action.list, { error: action.message }, action.requestId);

    case constants.GET_BILLS:
      return settle(state, 'bills', { data: { bills: action.payload } }, action.requestId);

    case constants.GET_INVOICES:
      return settle(state, 'invoices', { data: { invoices: action.payload } }, action.requestId);

    case constants.GET_UNDEPOSTED:
      return settle(state, 'undeposited', { data: { undeposited: action.payload } }, action.requestId);

    case constants.CLEAR_MATCH:
      return { bills: [], invoices: [], undeposited: [], requests: {}, loading: {}, errors: {}, apiError: false, loadCompleted: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/matchablesReducer.js